import { SalesAvailability, salesAvailableQuantity } from '../../services/sales-ordering/sales-delivery.service';

export default function SalesCartStock({ productId, quantity, availability, loading }: {
  productId: number; quantity: number; availability: SalesAvailability | null; loading: boolean;
}) {
  const available = salesAvailableQuantity(productId, availability);
  if (loading) return <div role="status" className="text-sm text-600 mt-2"><i className="pi pi-spin pi-spinner mr-2" aria-hidden="true" />Checking available quantity…</div>;
  if (!availability) return <div className="text-sm text-600 mt-2">Select a location and check stock to see availability.</div>;
  if (available === null) return <div className="text-sm text-600 mt-2">{availability.usesPosStock ? 'Quantity limit unavailable. Stock is checked before checkout.' : 'Standard stock availability applies.'}</div>;
  const exceeded = quantity > available;
  return <div className={`text-sm mt-2 ${exceeded ? 'text-red-600' : 'text-green-700'}`} role={exceeded ? 'alert' : undefined}>
    Available to order: <strong>{available}</strong>
    {availability.usesPosStock && <span className="block text-xs text-600">After open orders from the last 30 days.</span>}
    {exceeded && <span className="block">Reduce quantity to {available} or less, remove this item, or choose a different address.</span>}
  </div>;
}
